import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";

import { ComponentsModule } from "../../components/components.module";
import { FreeNasHeaderComponent } from "./header/header.component";
import { FreeNasLayoutComponent } from "./layout.component";

@NgModule({
  imports: [CommonModule, RouterModule, FormsModule, TranslateModule, ComponentsModule],
  declarations: [FreeNasLayoutComponent, FreeNasHeaderComponent],
  exports: [FreeNasLayoutComponent]
})
export class FreeNasLayoutModule {}
